import {Injectable} from '@angular/core';
import {ApiService} from './api.service';
import environment from '../../environment';
@Injectable()
export class CategoryService {
  constructor(protected Api: ApiService) {}

  public load() {
    return this.Api.get(
      `${environment.settings.registeredAwsUrl}/categories`
    ).then(({data}) => {
      return data;
    });
  }

 public loadCategoryProducts(category: string): Promise<any | null> {
  return this.Api.get(
    `${environment.settings.registeredAwsUrl}/categories/${category}`
  )
    .then((data) => {
      if (!data || Object.keys(data).length === 0) {
        return null; // category not found or empty
      }
      return data;
    })
    .catch((err) => {
      if (err.status === 404) {
        return null;
      }
      throw err; // let other errors bubble up
    });
}

}
